export default {
  name: "scroll-load",
  inserted(el, binding) {
    const cb = binding.value;
    // console.log("el", el);
    el.addEventListener(
      "scroll",
      (e) => {
        if (
          Math.ceil(e.target.scrollTop + e.target.clientHeight) >=
          e.target.scrollHeight
        ) {
          cb && cb();
        }
      },
      true
    );
  },
  unbind(el) {
    el.onscroll = null;
  },
};
